import { useCallback, useEffect, useLayoutEffect, useState } from "react";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import queryString from "querystring";

import { Button, Input, Row } from "antd";

import Swal from "sweetalert2";

import ApiService from "../../apis/ApiService_mall";
import channelUserApi from "../../apis/ChannelUser.api";
import partnersApi from "../../apis/Partners.api";
import { setChannelUser, setUser } from "../../redux/store/auth/authDuck";
import { setLoading } from "../../redux/store/common/commonDuck";
import BankListComponent from "../common/BankListComponent";
import PersonalAuthentication from "../common/PersonalAuthentication";

import SignUpHeader from "./SignUpHeader";

const api = new ApiService();
const TogetherSignup = () => {
	const user = useSelector((state) => state.auth.user);
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);

	const [certifiedData, setCertifiedData] = useState({});

	const dispatch = useDispatch();
	const history = useHistory();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [userValue, setUserValue] = useState({
		name: "",
		first_personal_number: "",
		second_personal_number: "",
		phone: "",
		email: "",
	});
	const [submitBank, setSubmitBank] = useState({
		bank_code: "",
		account_number: "",
	});

	const [agreement, setAgreement] = useState({
		policy: false,
		terms: false,
	});

	useLayoutEffect(() => {
		if (!user?.id) {
			Swal.fire({
				customClass: "alert-custom",
				text: "잘못된 접근입니다.",
				confirmButtonText: "확인",
			}).then(() => {
				// alert("잘못된 접근입니다.");
				history.goBack();
			});
		}
	}, []);

	useEffect(() => {
		window.scrollTo({ top: 0 });
	}, []);

	/**
	 * 회원 정보 받기
	 * @type {(function(*): void)|*}
	 */
	const handleInputUser = useCallback(
		(e) => {
			const { value, name } = e.target;

			// 주민번호 앞자리
			if (name === "first_personal_number") {
				if (value.split("-").join("").length <= 6) {
					let number = value.replace(/[^0-9]/g, "");
					setUserValue({
						...userValue,
						first_personal_number: number,
					});
				}
			}
			// 주민번호 뒷자리
			else if (name === "second_personal_number") {
				if (value.split("-").join("").length <= 7) {
					let number = value.replace(/[^0-9]/g, "");
					setUserValue({
						...userValue,
						second_personal_number: number,
					});
				}
			}
			// 휴대폰 번호
			else if (name === "phone") {
				if (value.split("-").join("").length <= 11) {
					let phone = value.replace(/[^0-9]/g, "");
					setUserValue({
						...userValue,
						phone: phone,
					});
				}
			} else {
				setUserValue({
					...userValue,
					[name]: value,
				});
			}
		},
		[userValue]
	);

	/**
	 * 가입하기 버튼 클릭
	 */
	const handleSignupButton = () => {
		// 유저 - 이름, 주민번호(앞/뒤), 휴대폰, 이메일
		// 계좌 - 은행코드, 계좌번호
		// 수집 동의 - 개인정보 처리방침, 고유식별정보 수집 및 이용
		let valid =
			userValue.name?.length > 0 &&
			userValue.first_personal_number?.length > 0 &&
			userValue.second_personal_number?.length > 0 &&
			userValue.phone?.length > 0 &&
			userValue.email?.length > 0 &&
			submitBank.bank_code?.length > 0 &&
			submitBank.account_number?.length > 0 &&
			agreement.policy &&
			agreement.terms &&
			certifiedData.is_certified;

		if (valid) {
			setIsLoading(true);
			const timer = setTimeout(() => {
				updateUserInformation();
			}, 100);
			return () => clearTimeout(timer);
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "필수 입력 항목을 모두 적어주세요.",
				confirmButtonText: "확인",
				// confirmButtonColor: "#212529",
			});
			const timer = setTimeout(() => {
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				});
			}, 100);
			return () => clearTimeout(timer);
		}
	};

	const updateUserInformation = async () => {
		let param = {
			id: user.id,
			key: "additional_info",
			name: userValue.name,
			email: userValue.email,
			phone: userValue.phone,
			personal_number:
				userValue.first_personal_number +
				"-" +
				userValue.second_personal_number,
			bank_code: submitBank.bank_code,
			account_number: submitBank.account_number,
			is_app: false,
		};
		// console.log(param, certifiedData);
		const res = await partnersApi.postPersonalUserData(param);
		if (res.code === 200) {
			dispatch(
				setUser({
					...user,
					bank_code: res.result?.bank_code,
					account_number: res.result?.account_number,
					nickname: res.result?.nickname,
					phone: res.result?.phone,
					is_influencer: true,
				})
			);

			Swal.fire({
				customClass: "alert-custom",
				text: `투게더 가입을 환영합니다!`,
				confirmButtonText: "확인",
			}).then(() => {
				history.replace("/dashboard");
			});
		} else if (res.code === 998) {
			Swal.fire({
				customClass: "alert-custom",
				text: "입력하신 이름이나 연락처가\n인증된 정보와 일치하지 않습니다.",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("updateUserInformation");
			});
		}
		setIsLoading(false);
	};

	/**
	 * 로그아웃
	 * @returns {Promise<void>}
	 */
	const logout = async () => {
		setIsLoading(true);
		Swal.fire({
			customClass: "alert-custom",
			text: `정말 로그아웃 하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				const param = {
					id: user.id,
				};
				await partnersApi.logout(param);
				localStorage.removeItem("admin:accessToken");
				localStorage.removeItem("admin:refreshToken");

				dispatch(setChannelUser(null));
				dispatch(setUser(null));
				setIsLoading(false);
				history.push(`/`);
			}
		});
		setIsLoading(false);
	};

	return (
		<div className="main-wrap">
			{/* 모바일 헤더 추가 */}
			<SignUpHeader title={"추가 정보 입력"} />
			<div className="max-width-apply">
				{/* 기본 정보 */}
				<div className={`signup-form-parents`}>
					<h1
						className={`main-title`}
						id={`main-title`}
						style={{ margin: 0, paddingBottom: "0.5em" }}
					>
						추가 정보 입력
					</h1>
					<div className={`signup-component-list`}>
						<h2>기본 정보</h2>
					</div>
					<div className={`signup-form-wrap`}>
						{/* 이름 */}
						<div className={`signup-form-item divider`}>
							<label>
								이름
								<div className={`item-required-div`}>
									<span className={`item-required`}>*</span>
								</div>
							</label>
							<div className={`input-div phone`}>
								<Input
									type={`text`}
									placeholder={`이름을 입력해주세요.`}
									value={userValue.name}
									name={"name"}
									onChange={handleInputUser}
									disabled={isLoading}
								/>
							</div>
						</div>
						{/* 주민번호 */}
						<div
							className={`signup-form-item divider`}
							style={{
								flexDirection: "column",
								alignItems: "flex-start",
								gap: "1em",
							}}
						>
							<div className={`signup-form-item`} style={{ width: "100%" }}>
								<label>
									주민등록번호
									<div className={`item-required-div`}>
										<span className={`item-required`}>*</span>
									</div>
								</label>
								<div className={`input-div personal-number`}>
									<div className={`personal-number-layout`}>
										<Input
											type={`text`}
											placeholder={``}
											value={userValue.first_personal_number}
											name={"first_personal_number"}
											onChange={handleInputUser}
											pattern={`/d*`}
											disabled={isLoading}
										/>
										<p>-</p>
									</div>
									<div className={`personal-number-layout`}>
										<Input
											type={`password`}
											placeholder={``}
											value={userValue.second_personal_number}
											name={"second_personal_number"}
											onChange={handleInputUser}
											pattern={`/d*`}
											disabled={isLoading}
										/>

										{/* 본인 인증 */}
										<PersonalAuthentication
											certifiedData={certifiedData}
											setCertifiedData={setCertifiedData}
											disabled={
												!userValue.name.length ||
												!userValue.first_personal_number.length ||
												!userValue.second_personal_number.length
											}
										/>
									</div>
								</div>
							</div>
							<p className={`point-text`}>
								<span>대금 정산</span>을 위하여 주민등록번호를 소득세법 제
								145조에 따라 수집이용하며, 이 법에 따라 5년 동안 보관합니다.
								{"\n"}
								가입시 확인한 본인 인증 정보와 동일한 주민등록 정보가 제공되어야
								합니다.
							</p>
						</div>
						{/* 휴대폰 번호 */}
						<div className={`signup-form-item divider`}>
							<label>
								휴대폰 번호
								<div className={`item-required-div`}>
									<span className={`item-required`}>*</span>
								</div>
							</label>
							<div className={`input-div phone`}>
								<Input
									type={`text`}
									placeholder={`- 없이 입력해주세요.`}
									value={userValue.phone}
									name={"phone"}
									pattern={`/d*`}
									onChange={handleInputUser}
									disabled={isLoading}
								/>
							</div>
						</div>
						{/* 이메일 */}
						<div className={`signup-form-item divider`}>
							<label>
								이메일
								<div className={`item-required-div`}>
									<span className={`item-required`}>*</span>
								</div>
							</label>
							<div className={`input-div phone`}>
								<Input
									type={`emailAddress`}
									placeholder={`이메일을 입력해주세요.`}
									value={userValue.email}
									name={"email"}
									onChange={handleInputUser}
									disabled={isLoading}
								/>
							</div>
						</div>
						{/* 계좌번호 */}
						<div className={`signup-form-item padding`}>
							<label>
								계좌번호
								<div className={`item-required-div`}>
									<span className={`item-required`}>*</span>
								</div>
							</label>
							<div className={`input-div phone`}>
								<BankListComponent
									submitBank={submitBank}
									setSubmitBank={setSubmitBank}
								/>
							</div>
						</div>
						{/* 계좌 소유자 */}
						<div
							className={`signup-form-item divider`}
							style={{ paddingTop: 0 }}
						>
							<label>계좌 소유자</label>
							<div className={`input-div phone`}>
								<Input
									type={`emailAddress`}
									placeholder={``}
									value={userValue.name}
									name={"name"}
									onChange={handleInputUser}
									disabled={true}
									style={{
										width: "60%",
									}}
								/>
							</div>
						</div>
					</div>
				</div>

				{/* 대금 정산 및 지급을 위한 정보 수집 동의 */}
				<div className={`signup-form-parents`} style={{ marginTop: "3em" }}>
					<div className={`signup-component-list`}>
						<h2 style={{ margin: 0 }}>
							대금 정산 및 지급을 위한 정보 수집 동의
						</h2>
					</div>
					<p className={`point-text`} style={{ fontSize: "1.1em" }}>
						당영투게더가 계좌 인증 및 정산 대금 지급을 위한 목적으로
						개인정보(계좌정보 포함) 및 고유식별정보를 수집 및 이용하며, 회원의
						개인정보를 안전하게 취급하는데 최선을 다합니다.
					</p>

					<div className={`signup-form-wrap`}>
						<div className={`signup-agreement-wrap`}>
							<div
								className={`signup-agreement-div`}
								onClick={() => {
									setAgreement({
										...agreement,
										policy: !agreement?.policy,
									});
								}}
							>
								<img
									src={`/assets/images/check-${
										agreement.policy ? "active" : "disabled"
									}.png`}
									alt={`약관 동의 1`}
								/>
								<p>[필수] 개인정보 처리방침</p>
								<img
									src={`/assets/images/channel/right-arrow.png`}
									alt={`화살표`}
									style={{
										height: "2em",
										width: "2em",
										marginLeft: "auto",
									}}
									onClick={(e) => {
										e.stopPropagation();
										window.open("https://www.dangyoung.com/policy", "_blank");
									}}
								/>
							</div>
							<p style={{ color: "#a9b0b7" }}>
								회원님의 소중한 정보를 안전하게 지키겠다는 약속이에요.
							</p>
						</div>

						<div className={`signup-agreement-wrap`}>
							<div
								className={`signup-agreement-div`}
								onClick={() => {
									setAgreement({
										...agreement,
										terms: !agreement?.terms,
									});
								}}
							>
								<img
									src={`/assets/images/check-${
										agreement.terms ? "active" : "disabled"
									}.png`}
									alt={`약관 동의 2`}
								/>
								<p>[필수] 고유식별정보 수집 및 이용</p>
								<img
									src={`/assets/images/channel/right-arrow.png`}
									alt={`화살표`}
									style={{
										height: "2em",
										width: "2em",
										marginLeft: "auto",
									}}
									onClick={(e) => {
										e.stopPropagation();
										window.open("https://www.dangyoung.com/terms", "_blank");
									}}
								/>
							</div>
							<p style={{ color: "#a9b0b7" }}>
								회원님에게 안정적인 대금 정산을 하겠다는 약속이에요.
							</p>
						</div>
					</div>
				</div>
				<div className={`signup-blue-button-wrap`}>
					<Button
						loading={isLoading}
						className={`signup-blue-button`}
						onClick={handleSignupButton}
					>
						완료
					</Button>
				</div>
				<Row justify={"center"}>
					<button
						className={`channel-withdraw`}
						style={{ color: "#ced4da" }}
						onClick={logout}
					>
						로그아웃
					</button>
				</Row>
			</div>
		</div>
	);
};

export default TogetherSignup;
